import { createSelector } from '@reduxjs/toolkit';

const selectFirstVideoShareModal = state => state.firstVideoShareModal;

export const selectFirstVideoShareModalIsOpen = createSelector(
  selectFirstVideoShareModal,
  modal => modal.isOpen
);
